import { render, staticRenderFns } from "./inline-time-period.vue?vue&type=template&id=0fb5797a&"
import script from "./inline-time-period.vue?vue&type=script&lang=js&"
export * from "./inline-time-period.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports